export const STEP_STATUS = {
  active: "In progress",
  completed: "Completed",
  did_it: "Done",
  made_progress: "Progress made",
  changed_step: "New direction",
  got_stuck: "A hurdle",
  released: "Released",
  paused: "Paused",
};

export const SUPPORT_OPTIONS = [
  "Just witness this",
  "Encourage me",
  "Check in with me",
  "Help me think it through",
  "Share experience/advice",
  "Help me find something",
  "I'd like to do this with someone",
];

export const RESPONSE_KINDS = [
  { kind: "cheer", label: "Cheer them on" },
  { kind: "check_in", label: "I'll check in" },
  { kind: "experience", label: "I have experience with this" },
  { kind: "help", label: "I can help" },
  { kind: "here", label: "I'm here" },
];

export const REFLECT_OUTCOMES = [
  { key: "did_it", label: "I did it" },
  { key: "made_progress", label: "I made progress" },
  { key: "changed_step", label: "I changed my next step" },
  { key: "got_stuck", label: "I got stuck" },
  { key: "released", label: "This isn't what I want anymore" },
];

export const CHAT_PLATFORMS = ["WhatsApp", "Messages/iMessage", "GroupMe", "Slack", "Messenger", "Other"];

export const POD_PURPOSES = [
  { key: "accountability", label: "Accountability circle",
    suggestion: "We help each other follow through on what matters.",
    gatherings: ["Weekly check-in call", "Monthly wins dinner"] },
  { key: "creative", label: "Creative support",
    suggestion: "We make things and share them before they're perfect.",
    gatherings: ["Co-working session", "Share-what-you-made night"] },
  { key: "family", label: "Family & close friends",
    suggestion: "We stay close on purpose.",
    gatherings: ["Sunday dinner", "A standing birthday walk"] },
  { key: "mastermind", label: "Mastermind",
    suggestion: "We think out loud together and borrow each other's brains.",
    gatherings: ["Monthly deep-dive", "Hot-seat evening"] },
  { key: "money", label: "Growing money",
    suggestion: "We talk openly about money and help each other grow it.",
    gatherings: ["Monthly money check-in", "Investing ideas night"] },
  { key: "transitions", label: "Life transitions",
    suggestion: "We show up for each other while things change.",
    gatherings: ["Coffee & catch-up", "Seasonal reflection"] },
  { key: "connection", label: "Just staying connected",
    suggestion: "No agenda. We're the point.",
    gatherings: ["Group walk", "Movie night"] },
  { key: "unsure", label: "We're still figuring it out", suggestion: "", gatherings: [] },
  { key: "custom", label: "Write our own", suggestion: "", gatherings: [] },
];

export const EVENT_LABELS = {
  intention_created: "Intentions named",
  step_created: "Next steps declared",
  step_shared: "Steps shared with a pod",
  help_requested: "Requests for help",
  support_response: "Support offered",
  reflection_completed: "Reflections completed",
  outcome_did_it: "Steps completed",
  outcome_made_progress: "Steps with progress",
  outcome_changed_step: "Steps reframed",
  outcome_got_stuck: "Steps that hit a hurdle",
  outcome_released: "Steps released",
  moment_created: "Moments captured",
  gathering_created: "Gatherings created",
  gathering_rsvp: "Gathering RSVPs",
  pod_created: "Pods formed",
};
